<form *ngIf="step2Form" [formGroup]="step2Form" class="definition-form" id="ce-prj2-form">
  <mat-form-field class="project-purpose" floatLabel="auto" subscriptSizing="dynamic" id="ce-prj2-purpose-ff">
    <mat-label id="ce-prj2-purpose-label">Project Name</mat-label>
    <input matInput maxlength="500" formControlName="purpose" required id="ce-prj2-purpose" />
    <mat-error
      *ngIf="step2Form.get('purpose')?.hasError('required') && step2Form.get('purpose')?.touched"
      id="ce-prj2-purpose-err"
    >
      Project name is required.
    </mat-error>
    <mat-error
      *ngIf="step2Form.get('purpose')?.hasError('whitespace') && !step2Form.get('purpose')?.hasError('required')"
      id="ce-prj2-purpose-ws"
    >
      Project name cannot be empty or contain only spaces
    </mat-error>
    <mat-error *ngIf="step2Form.get('purpose')?.hasError('duplicateProject')" id="ce-prj2-purpose-dup">
      A project with this name already exists
    </mat-error>
    <mat-hint align="end" id="ce-prj2-purpose-hint">{{ step2Form.get('purpose')?.value?.length || 0 }} / 500</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="fill" class="w-100 description-field" subscriptSizing="dynamic" id="ce-prj2-desc-ff">
    <mat-label id="ce-prj2-desc-label">Description</mat-label>
    <textarea
      matInput
      rows="2"
      formControlName="description"
      required
      placeholder="Enter description"
      maxlength="1000"
      id="ce-prj2-desc"
    ></textarea>
    <mat-error
      *ngIf="step2Form.get('description')?.hasError('required') && step2Form.get('description')?.touched"
      id="ce-prj2-desc-err"
    >
      Description is required.
    </mat-error>
    <mat-error
      *ngIf="
        step2Form.get('description')?.hasError('whitespace') && !step2Form.get('description')?.hasError('required')
      "
      id="ce-prj2-desc-ws"
    >
      Description cannot be empty or contain only spaces
    </mat-error>
    <mat-hint align="end" id="ce-prj2-desc-hint">
      {{ step2Form.get('description')?.value?.length || 0 }} / 1000
    </mat-hint>
  </mat-form-field>
  <div class="form-group date-fields" id="ce-prj2-date-fields">
    <mat-form-field floatLabel="auto" subscriptSizing="dynamic" style="width: 165px" id="ce-prj2-cost-ff">
      <mat-label id="ce-prj2-cost-label">Cost Target ($)</mat-label>
      <input matInput type="number" formControlName="projectCostTarget" required nonNegative id="ce-prj2-cost" />
      <mat-error
        *ngIf="
          (step2Form.get('projectCostTarget')?.hasError('required') ||
            step2Form.get('projectCostTarget')?.hasError('min')) &&
          step2Form.get('projectCostTarget')?.touched
        "
        id="ce-prj2-cost-err"
      >
        Cost must be greater than zero.
      </mat-error>
    </mat-form-field>
    <mat-label class="mr-20" id="ce-prj2-costunit-label"> / Oz</mat-label>
    <mat-form-field appearance="fill" subscriptSizing="dynamic" id="ce-prj2-start-ff">
      <mat-label id="ce-prj2-start-label">Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        required
        readonly
        (click)="startPicker.open()"
        [matDatepickerFilter]="dateFilter"
        id="ce-prj2-start"
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker [startAt]="step2Form.get('startDate')?.value"></mat-datepicker>
      <mat-error
        *ngIf="step2Form.get('startDate')?.hasError('required') && step2Form.get('startDate')?.touched"
        id="ce-prj2-start-err"
      >
        Start Date is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field
      appearance="fill"
      subscriptSizing="dynamic"
      [ngClass]="{ 'end-date-field': step2Form.get('endDate')?.value }"
      id="ce-prj2-end-ff"
    >
      <mat-label id="ce-prj2-end-label">End Date / Deadline</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        readonly
        (click)="endPicker.open()"
        [min]="step2Form.get('startDate')?.value"
        id="ce-prj2-end"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="clearEndDate()"
        *ngIf="step2Form.get('endDate')?.value"
        matTooltip="Clear end date"
        class="clear-date-btn"
        id="ce-prj2-end-clear"
      >
        <mat-icon>clear</mat-icon>
      </button>
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
</form>
